/* src/app/vehicle/pages/vehicles-vor-cancel/vehicles-vor-cancel.component.scss */
/*# sourceMappingURL=vehicles-vor-cancel.component.css.map */
